import { render, staticRenderFns } from "./KnajzaPolicyCancel.vue?vue&type=template&id=451ac3a3&scoped=true&"
import script from "./KnajzaPolicyCancel.vue?vue&type=script&lang=js&"
export * from "./KnajzaPolicyCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451ac3a3",
  null
  
)

export default component.exports